import { createSlice } from "@reduxjs/toolkit";
import { dashboardApi } from "../services/dashboardApi";

const initialState = {
  dashboardData: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        dashboardApi.endpoints.getDashboardData.matchFulfilled,
        (state, { payload }) => {
          state.dashboardData = payload.data;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getDashboardData.matchRejected,
        (state, { payload }) => {
          state.dashboardData = null;
        }
      );
  },
});

export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
